export default "__VITE_ASSET__CGYzzB99__"